/* eslint-disable */
import {
  Checkbox,
  createStyles,
  Divider,
  Fab,
  FormControlLabel,
  FormGroup,
  makeStyles,
  Slide,
  Switch,
  TextField,
} from "@material-ui/core";
import styles from "./FilterWiget.module.css";
import React, { memo, useCallback, useEffect } from "react";
import FilterListIcon from "@material-ui/icons/FilterList";
import PresenterIcon from "@material-ui/icons/Person";
// import ProjectIcon from "@material-ui/icons/Work";
import { VideoFilter } from "../../video/models/VideoFilter";
import { Video } from "../../video/models/Video";
import { useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import CheckboxIcon from "../images/CheckboxIcon";
import CheckboxCheckedIcon from "../images/CheckboxCheckedIcon";
import { createTheme, Theme } from "@mui/material/styles";
import useResponsive from "../../../common/useResponsive";

import { isAdmin } from "../../../utils/LogicUtils";

const theme = createTheme();
interface checkObject {
  [key: string]: boolean;
}

interface FilterWigetProps {
  videos: Video[];
  videoFilter: VideoFilter;
  checkedItems: checkObject;
  changeProfessionalFilter?: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  changeProjectFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeSlideFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeTagFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: "relative",
      marginTop: theme.spacing(3),
    },
    actionButton: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      zIndex: 200,
      backgroundColor: "var(--red)",
      "&:hover": {
        backgroundColor: "rgb(193, 0, 25)",
      },
    },
    listIcon: {
      color: "var(--white)",
    },
    divider: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(-1),
    },
    icon: {
      color: "var(--red)",
      marginRight: "8px",
    },
    tagCheckBox: {
      marginLeft: theme.spacing(1),
      marginBottom: "-12px",
    },
    formGroupRoot: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
    },
    conditionSelect: {
      width: "100%",
      "& .MuiInputLabel-root.Mui-focused": {
        color: "rgba(0, 0, 0, 0.54)",
      },
      "& .MuiFilledInput-underline:after": {
        borderBottom: "2px solid rgba(0, 0, 0, 0.54)",
      },
    },
    conditionSelectMobile: {
      "& .MuiSelect-filled": {
        padding: "20px 10px 6px",
        fontSize: "14px",
      },
    },
  })
);

function FilterWiget({
  videos,
  videoFilter,
  checkedItems,
  changeProfessionalFilter,
  changeProjectFilter,
  changeSlideFilter,
  changeTagFilter,
}: FilterWigetProps) {
  const classes = useStyles();
  const { isMobile } = useResponsive();
  const [openFilterModal, setOpenFilterModal] = React.useState(false);
  const [selectProfessional, setSelectProfessional] = React.useState<string[]>([
    "",
  ]);


  // const [selectProject, setSelectProject] = React.useState<string[]>([""]);

  const { projectList } = useSelector(({ exProject }: AppState) => exProject);
  const { tags } = useSelector(({ video }: AppState) => video);

  const handleOuterClick = useCallback(() => {
    setOpenFilterModal(false);
    document.removeEventListener("click", handleOuterClick);
  }, []);

  const handleOpen = useCallback(
    (toSet: boolean) => () => {
      setOpenFilterModal(toSet);

      if (toSet) {
        document.addEventListener("click", handleOuterClick);
      } else {
        document.removeEventListener("click", handleOuterClick);
      }
    },
    [setOpenFilterModal, handleOuterClick]
  );

  const handlePropagation = useCallback((event: React.MouseEvent) => {
    event.nativeEvent.stopImmediatePropagation();
  }, []);

  const changeProfessionalHandle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (changeProfessionalFilter) {
        changeProfessionalFilter(event);
      }
    },
    [changeProfessionalFilter]
  );

  // const changeProjectHandle = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
  //     if (changeProjectFilter) {
  //         changeProjectFilter(event);
  //    }
  //}, [changeProjectFilter]);

  const changeTagHandle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (changeTagFilter) {
        changeTagFilter(event);
      }
    },
    [changeTagFilter]
  );

  const changeSlideHandle = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (changeSlideFilter) {
        changeSlideFilter(event);
      }
    },
    [changeSlideFilter]
  );

  useEffect(() => {
    const pList: string[] = [""];
    videos.forEach((element) => {
      if (!pList.includes(element.presenter)) {
        pList.push(element.presenter);
      }
    });
    setSelectProfessional(pList);

    const pjIds: number[] = [];
    videos.forEach((element) =>
      element.projectIds.forEach((id) => pjIds.push(id))
    );

    // const pjList: string[] = [""];
    // (new Set(pjIds)).forEach(pjId => {
    //     let tmpList = projectList.filter(project => project.id === String(pjId));
    //     if (tmpList.length > 0 && !pjList.includes(tmpList[0].title)) {
    //         pjList.push(tmpList[0].title);
    //    }
    //});
    // setSelectProject(pjList);
  }, [videos, projectList]);

  return (
    <div className={classes.wrapper} onClick={handlePropagation}>
      <Fab
        variant="circular"
        size="small"
        className={classes.actionButton}
        onClick={handleOpen(!openFilterModal)}
      >
        <FilterListIcon className={classes.listIcon} />
      </Fab>
      {/* {isAdmin(userInfo?.roles)&&(<Fab
        variant="circular"
        size="small"
        className={classes.actionButton}
        onClick={handleOpen(!openFilterModal)}
      >
        <FilterListIcon className={classes.listIcon} />
      </Fab>)} */}
      <Slide direction="left" in={openFilterModal} mountOnEnter unmountOnExit>
        <div className={styles.widget}>
          <div className={styles.condArea}>
            <div className={styles.widgetSubTitle}>
              <PresenterIcon className={classes.icon} />
              <PuiTypography size={isMobile ? 16: 20} bold={true}>
                Presenterで絞り込む
              </PuiTypography>
            </div>
            <TextField
              id="professionalFilter"
              label="Presenter"
              select
              SelectProps={{ native: true }}
              variant="filled"
              size="small"
              onChange={changeProfessionalHandle}
              value={videoFilter.professional[0]}
              className={`${classes.conditionSelect} ${isMobile && classes.conditionSelectMobile}`}
            >
              {selectProfessional.map((value, index) => (
                <option key={index} value={value}>
                  {value}
                </option>
              ))}
            </TextField>
            <div className={styles.widgetSubTitle}>
              <LibraryBooksIcon
                className={classes.icon}
                style={{ color: "var(--red)" }}
              />
              <PuiTypography size={isMobile ? 16 : 20} bold={true}>
                Slideで絞り込む
              </PuiTypography>
              <div style={{ marginLeft: isMobile? "15px" : "80px" }}>
                <Switch
                  onChange={changeSlideHandle}
                  name="checkedSlide"
                  checked={videoFilter.slideFlg}
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              </div>
            </div>
            <Divider
              variant="fullWidth"
              className={classes.divider}
              style={{ marginTop: "-5px" }}
            />

            <div className={styles.widgetTagTitle}>
              <PuiTypography size={isMobile ? 16 : 20} bold={true}>
                Tagで絞り込む
              </PuiTypography>
            </div>
          </div>
          <FormGroup
            className={styles.tagArea}
            classes={{ root: classes.formGroupRoot }}
          >
            {tags.map((item, index) => (
              <div key={index} className={styles.widgetCheckbox}>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={
                        <div className={styles.checkedIcon}>
                          <CheckboxIcon />
                        </div>
                      }
                      checkedIcon={
                        <div className={styles.checkedIcon}>
                          <CheckboxCheckedIcon />
                        </div>
                      }
                      checked={checkedItems[item.tag] || false}
                      onChange={changeTagHandle}
                      name={item.tag}
                    />
                  }
                  label={
                    <div className={styles.widgetCheckboxText}>
                      <div
                        className={styles.widgetCheckboxTag}
                        data-tip={item.tag}
                        data-for="tagName"
                      >
                        <PuiTypography size={isMobile ? 14 : 16}>{item.tag}</PuiTypography>
                      </div>
                      <PuiTooltip id="tagName" />
                      <PuiTypography color="gray-61" size={isMobile ? 14 : 16}>{`${item.tagCount} Video(s)`}</PuiTypography>
                    </div>
                  }
                  className={classes.tagCheckBox}
                />
              </div>
            ))}
          </FormGroup>
        </div>
      </Slide>
    </div>
  );
}

export default memo(FilterWiget);
